import {Component, OnInit} from '@angular/core';
import {FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Managementtype} from '../../../model/Managementtype';
import {Datetype} from '../../../model/Datetype';
import {LocalStorage} from '../../../../global/util/LocalStorage';
import {InformType} from '../../../../global/util/enum/InformType';
import {Dialog} from '../../../../global/util/Dialog';
import {ManagementService} from '../../../service/management.service';
import {Management} from '../../../model/Management';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-add-manage-document',
  templateUrl: './add-manage-document.component.html',
  styleUrls: ['./add-manage-document.component.css']
})
export class AddManageDocumentComponent implements OnInit {
  manageDocumentForm: FormGroup;
  title = 'TITLE.MANAGEMENT-DOCUMENT';
  dateTypes: Datetype[] = [];
  managementTypes: Managementtype[] = [];
  dateTypeSelected: any;
  managementTypeSelected: any;
  private loading: boolean;
  managements: Management[] = [];
  index = 0;
  indexIncrement = 0;
  disabledOption = false;

  constructor(private activeModal: NgbActiveModal,
              private fb: FormBuilder,
              private managementService: ManagementService,
              private translate: TranslateService) {
    this.createForm();
  }

  ngOnInit(): void {
    this.dateTypes = LocalStorage.getDatetypes();
    this.managementTypes = LocalStorage.getManagementtypes();
    this.dateTypeSelected = this.dateTypes[0];
    this.managementTypeSelected = this.managementTypes[this.indexIncrement];
  }

  cancel() {
    this.activeModal.close(null);
  }

  save() {
    if (this.manageDocumentForm.invalid) {
      this.manageDocumentForm.markAllAsTouched();
      return;
    }

    for (let index = 0; index < this.arrayManagementDocument.controls.length; index++) {
      const group = this.arrayManagementDocument.controls[index];
      if (group instanceof FormGroup) {
        const formData = new FormData();
        formData.append('managementId', group.get('managementType').value);
        formData.append('time', group.get('time').value);
        formData.append('dateTypeId', group.get('dateType').value.id);
        this.managementService.save(formData).subscribe((result: any) => {
          this.managements.push(result);
          this.activeModal.close(this.managements);
        }, error => {
          Dialog.show(InformType.Danger, this.translate.instant('TITLE.MANAGEMENT-DOCUMENT'), this.translate.instant('THE-REQUESTED-OPERATION-WAS-NOT-COMPLETED'));
        });
      }
    }

  }

  private createForm() {
    this.manageDocumentForm = this.fb.group({
      managementType: [this.managementTypeSelected],
      arrayManagementDocument: this.fb.array([])
    });
  }

  public addRow() {
    this.index = 0;
    const group = this.fb.group({
      description: [this.managementTypeSelected.name],
      managementType: [this.managementTypeSelected.id],
      time: [null, [Validators.compose([
        Validators.required,
        Validators.pattern('^[1-9][0-9]*$')
      ])]],
      dateType: [this.dateTypeSelected]
    });
    this.arrayManagementDocument.push(group);
  }

  reAddRow() {
    if (!this.arrayManagementDocument.controls.length) {
      this.addRow();
    } else if (this.managementTypeSelected.id !== this.arrayManagementDocument.controls[0].get('managementType').value) {
      this.addRow();
    } else {
      Dialog.show(InformType.Warning, this.translate.instant('TITLE.MANAGEMENT-DOCUMENT'), this.translate.instant('MESSAGE.TYPE-MANAGEMENT-HAS-ALREADY-BEEN-ADD'));
    }
  }

  get arrayManagementDocument() {
    return this.manageDocumentForm.get('arrayManagementDocument') as FormArray;
  }

  delete(index) {
    this.arrayManagementDocument.removeAt(index);
  }

  get managemetTypeAddedDisabled() {
    for (let index = 0; index > this.arrayManagementDocument.controls.length; index++) {
      const group = this.arrayManagementDocument.at(index);
      if (group) {
        return group.get('description').value === this.manageDocumentForm.get('managementType').value.name;
      }
    }
  }

  get disabledBtnAdd() {
    return this.managementTypes.length === this.arrayManagementDocument.controls.length;
  }

  isInvalidControls(index: number, ctrlName: string) {
    return (this.manageDocumentForm.get('arrayManagementDocument') as FormArray).controls[index].get(ctrlName).invalid
      && (this.manageDocumentForm.get('arrayManagementDocument') as FormArray).controls[index].get(ctrlName).touched;
  }

  getErrorMessage(index: number, ctrlName: string) {
    return (this.manageDocumentForm.get('arrayManagementDocument') as FormArray).controls[index].get(ctrlName).hasError('required') ? this.translate.instant('MESSAGE.THE-NUMBER-IS-REQUIRED') : this.translate.instant('MESSAGE.ENTER_NUMBER_GREATER_THAN_ZERO');
  }
}
